import { createSlice } from '@reduxjs/toolkit';
import { IQuestionsState } from './types';
import {
  TChatMessagesResponse,
  TChatResponse,
} from 'src/api/base/Questions/types';

const initialState: IQuestionsState = {
  listAndMessagesSwitcher: false,
  chatInfo: {
    id: undefined,
    fullname: undefined,
    avatar: undefined,
    last_message_date: undefined,
    message: undefined,
    is_read_last_message: undefined,
  },
  chatMessages: [],
  chatsList: [],
  isSendChatMessage: false,
  isLoadingChatMessages: false,
  isLoadingChatsList: false,
  isSendFiles: false,
};

const createQuestionsSlice = createSlice({
  name: 'questions',
  initialState,
  reducers: {
    setListAndMessagesSwitcher(state, { payload }: { payload: boolean }) {
      state.listAndMessagesSwitcher = payload;
    },
    clearChat(state) {
      state.chatInfo.id = undefined;
    },
    setChatInfo(state, { payload }: { payload: TChatResponse }) {
      state.chatInfo = payload;
    },
    setChatMessages(state, { payload }: { payload: TChatMessagesResponse[] }) {
      state.chatMessages = payload;
    },
    setSendChatMessage(state, { payload }: { payload: boolean }) {
      state.isSendChatMessage = payload;
    },
    setSendFiles(state, { payload }: { payload: boolean }) {
      state.isSendFiles = payload;
    },
    setChatsList(state, { payload }: { payload: TChatResponse[] }) {
      state.chatsList = payload;
    },
    setLoadingChatsList(state, { payload }: { payload: boolean }) {
      state.isLoadingChatsList = payload;
    },
    setLoadingChatMessages(state, { payload }: { payload: boolean }) {
      state.isLoadingChatMessages = payload;
    },
  },
});

export const {
  setListAndMessagesSwitcher,
  setChatInfo,
  setChatMessages,
  setSendChatMessage,
  setChatsList,
  setLoadingChatsList,
  setLoadingChatMessages,
  clearChat,
  setSendFiles,
} = createQuestionsSlice.actions;

export const createQuestionsReducer = createQuestionsSlice.reducer;
